import React from "react";
import { useLocation } from "react-router-dom";
import { Header } from "../components/site/Header";
import { Hero } from "../components/site/Hero";
import { Marquee } from "../components/site/Marquee";
import { Founder } from "../components/site/Founder";
import { Manifesto } from "../components/site/Manifesto";
import { Newsletter } from "../components/site/Newsletter";
import { CraApplicabilityChecker } from "../components/site/CraApplicabilityChecker";
import { Contact } from "../components/site/Contact";
import { Footer } from "../components/site/Footer";
import { SEO } from "../components/site/SEO";
import { useI18n } from "../i18n";

export default function HomePage() {
  const location = useLocation();
  const { lang } = useI18n();

  // Note: scroll positioning (top-of-page or #hash) is handled globally by
  // <ScrollToTop /> via Lenis. Doing it here as well with native
  // scrollIntoView({behavior:"smooth"}) desyncs Lenis from documentElement
  // scrollTop and causes the next SPA navigation to paint a blank/black view.

  // Page-level JSON-LD: the global SEO component already emits Organization,
  // Person, WebSite, WebPage and the homepage Service node as a single @graph.
  // (The previous custom LegalService node was removed — NexTech.Law is a
  // consultancy, not a law firm.)

  return (
    <>
      <SEO
        path="/"
        lang={lang}
        altLang={{ hreflang: lang === "de" ? "en" : "de", href: "https://nextech.law/" }}
        description={
          lang === "de"
            ? "CRA, AI Act und NIS2 sicher umsetzen: Juristische Expertise, unternehmerische Erfahrung und Compliance-Tools für Hersteller und KMU. CRA-Check buchen."
            : "Implement CRA, AI Act and NIS2 with confidence: legal expertise, entrepreneurial experience and compliance tools for manufacturers and SMEs. Book a CRA check."
        }
      />
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Founder />
        <Manifesto />
        <Newsletter />
        <CraApplicabilityChecker />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
